import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useSiteConfig } from 'hooks/useSiteConfig';
import { MAX_PRODUCT_PAGE_SIZE } from 'utils/products';
import { useIsCrawler } from 'hooks/useIsCrawler';

type CrawlersPaginationProps = {
  totalProductsCount: number;
};

const CrawlersPagination = ({
  totalProductsCount,
}: CrawlersPaginationProps) => {
  const router = useRouter();
  const { host } = useSiteConfig();
  const isCrawler = useIsCrawler();

  const pageParam = router.query.page;
  const serverPage = Number(pageParam) > 1 ? Number(pageParam) : 1;
  const prevPage = serverPage > 2 ? serverPage - 1 : 1;
  const nextPage = serverPage + 1;
  const isFinalPageOfResults =
    serverPage * MAX_PRODUCT_PAGE_SIZE >= totalProductsCount;

  const [pathname] = router.asPath.split('?');
  const protocol = host.startsWith('localhost') ? 'http://' : 'https://';

  useEffect(() => {
    if (pageParam && !Boolean(router?.query?.offset)) {
      const offset = (serverPage - 1) * MAX_PRODUCT_PAGE_SIZE;

      router.replace(
        {
          query: {
            ...router.query,
            offset: offset,
          },
        },
        '',
        { scroll: false }
      );
    }
  }, [pageParam, router, serverPage]);

  if (!isCrawler) return null;

  return (
    <div
      className={`text-puma-black text-base`}
      data-test-id="crawlers-pagination"
    >
      {serverPage > 1 && (
        <a
          href={`${protocol}${host}${pathname}${
            serverPage === 2 ? '' : `?page=${prevPage}`
          }`}
          className="mr-1"
        >
          Previous
        </a>
      )}
      {!isFinalPageOfResults && (
        <a href={`${protocol}${host}${pathname}?page=${nextPage}`}>Next</a>
      )}
    </div>
  );
};

export default CrawlersPagination;
